export default __webpack_public_path__ + "static/media/rihanna.13d631cc.jpg";